import { api } from './api';

export interface IRelease {
  id: string;
  notionUrl: string;
  version: string;
  description: string;
  userType: 'all' | 'dentist' | 'designer' | 'specialist' | 'manufacturer';
}

export const releaseNotesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getLatestReleaseNotes: build.query<IRelease, void>({
      query: () => '/user/v1/releases/latest',
    }),
  }),
});

export const { useGetLatestReleaseNotesQuery } = releaseNotesApi;
